import {
  _2dMapQuote,
  _2dMapQuoteTypes,
} from '@larki/shared/type/order.v2';
import { redistributeOverriddenItems } from '@larki/shared/quote/redistribute-overridden-items';
import text from '../../../text';
import { getGroupText } from '@/utilities/order.v2';
import { CardType } from './Section';
import {
  isUserGovernment,
  isUserUnderTrial,
  userHasValidMembership,
  isUserStaff,
} from '@/utilities/user';
import { UserT } from '@larki/shared/types/user.type';

interface GroupConfig {
  key: _2dMapQuoteTypes['group'];
  title: string;
}

const requestForQuoteGroups: GroupConfig[] = [
  { key: 'data_in_database', title: text('dataInDatabase') },
  { key: 'capture_services', title: text('getQuote3dScanCaptureServices') },
  { key: 'add_ons', title: 'Add ons' },
  { key: 'membership', title: 'Membership' },
];

const quoteCreatedGroups: GroupConfig[] = [
  { key: 'data_in_database', title: getGroupText('data_in_database') },
  { key: 'membership', title: 'Membership' },
];

export function splitQuoteDataIntoCards(
  quote: _2dMapQuote,
  startIndex = 0,
  groups: GroupConfig[] = requestForQuoteGroups
): (CardType & { index: number })[] {
  function chargesToCard(
    title: string,
    subQuote: _2dMapQuoteTypes['subQuote']
  ): CardType | null {
    if (
      !subQuote ||
      (subQuote.charges.length === 0 && subQuote.totals.fees.length === 0)
    )
      return null;
    return {
      title,
      subQuote,
    };
  }

  const cards = groups
    .map((group) => chargesToCard(group.title, quote.composition[group.key]))
    .filter((c): c is CardType => Boolean(c));

  return cards.map((c, i) => ({
    ...c,
    index: startIndex + i,
  }));
}

export { redistributeOverriddenItems };

const getIsEssentialUserFor = (user?: UserT) => {
  if (!user) return false;
  if (isUserGovernment(user)) return true;

  return (
    !isUserStaff(user.role) &&
    userHasValidMembership(user) &&
    !isUserUnderTrial(user)
  );
};

// Live `useUser` flags beat the activity payload (which may be stale) when
// the creator is the current user.
function getCreatorAsMember(
  createdUser: UserT | undefined,
  currentUser: {
    profile?: { id?: number } | null;
    isEssentialUser?: boolean;
    isGovernment?: boolean;
  }
): boolean {
  const isCreatedByCurrentUser =
    createdUser?.id != null && createdUser.id === currentUser.profile?.id;
  return isCreatedByCurrentUser
    ? !!(currentUser.isEssentialUser || currentUser.isGovernment)
    : getIsEssentialUserFor(createdUser);
}

export {
  requestForQuoteGroups,
  quoteCreatedGroups,
  getIsEssentialUserFor,
  getCreatorAsMember,
};

